import { z } from "zod";

export const formSchema = z.object({
  taxId: z.string().min(2, "Ingresa un RUC").max(11, "El RUC es inválido"),
  address: z
    .string()
    .min(2, "Ingresa una dirección")
    .max(100, "Máximo 100 caracteres"),
  tradeName: z
    .string()
    .min(2, "Escribe un nombre comercial válido")
    .max(100, "Máximo 100 caracteres"),
  website: z.string().url("Escribe una URL válida"),
  mainOffering: z
    .string()
    .min(1, "Debes indicar tu producto/servicio principal"),
  startYearOfOperations: z.union([
    z.coerce
      .number({ message: "Ingresa un año válido" })
      .min(1700, "Ingresa un año válido")
      .max(new Date().getFullYear(), "Ingresa un año válido"),
    z.literal("").refine(() => false, {
      message: "is required",
    }),
  ]),
});
